import { createStore } from '@qcx/store';
const initialState = {
    theme: null,
    isDarkMode: false
};
const { Provider, useStore } = createStore(initialState, ({ set }) => ({
    toggleDarkMode: () => {
        set(({ isDarkMode }) => ({ isDarkMode: !isDarkMode }));
    }
}));
export const useTheme = () => useThemeStore(s => s.theme);
export const ThemeStoreProvider = Provider;
export const useThemeStore = useStore;
